const withSlash = (url = "") => (url.endsWith("/") ? url : `${url}/`);

const DEV_API_URL = process.env.REACT_APP_API_BASE_DEV || "https://localhost:5001/api/";
const PROD_API_URL = process.env.REACT_APP_API_BASE_PROD || "https://api.everifpro.com/api/";

// Use separate base URLs for dev vs prod so publishing doesn’t require manual edits
export const apiurl = withSlash(
  process.env.NODE_ENV === "production" ? PROD_API_URL : DEV_API_URL
);
